<template>
    <div style="margin: 0px 16px 0 40px;">
        <div style="display: flex;align-items: center;margin: 20px 0 10px 0;padding: 0 0px 0px 10px; height: 120px;background: linear-gradient(to right, rgb(103,255,255,0.3),rgb(137,251,255,0.1), rgb(163,248,255,0));" @click="$router.replace('/brandnew/brandnewModel');">
            <div style="width:100px;">
                <el-image class="rotate-image" style="width: 80px; height: 80px" src="https://kaifaceshi.08170817.com/static/admin/menulogo.png" fit="fill"></el-image>
            </div>
            <div style="display: flex;flex-direction: column;">
                <div style="margin: 6px 0 6px 15px; font-size: 20px;font-weight: 600;color: #29FFF1;">芯云科技圣灵引擎</div>
                <div style="margin: 6px 0 6px 18px;font-size: 12px;font-weight: 600;color: #29FFF1;">到期时间：{{ supplierinfo.expire_time | strtime}}</div>
                <div style="margin: 6px 0 6px 0px;font-size: 12px;color: #29FFF1;">学习雷军，成为雷军，超越雷军！</div>
            </div>
        </div>
        <div id="scrollable-area" style="height: 80vh;">
            <el-menu :default-active="$route.path" class="el-menu-vertical-demo" background-color="#112f5000" text-color="#fff" active-text-color="#ffd04b00" :unique-opened="true" router>
                <el-submenu index="/brandnew" :class="$route.path.includes('brandnew')?'submenu-active':''">
                    <template slot="title">
                        <div @click="$router.replace('/brandnew/brandnewModel');" style="width: 100%;">全新机批发</div>
                    </template>
                </el-submenu>
                <el-submenu index="/battery" :class="$route.path.includes('battery')?'submenu-active':''">
                    <template slot="title">
                        <div @click="$router.replace('/battery/batteryModel');" style="width: 100%;">电池批发</div>
                    </template>
                </el-submenu>
                <el-submenu index="/model/modelList" :class="$route.path.includes('modelList')?'submenu-active':''">
                    <template slot="title">
                        <div @click="$router.replace('/model/modelList');" style="width: 100%;">美妆批发</div>
                    </template>
                </el-submenu>
                <el-submenu index="/model/modelList" :class="$route.path.includes('modelList')?'submenu-active':''">
                    <template slot="title">
                        <div @click="$router.replace('/model/modelList');" style="width: 100%;">屏幕批发</div>
                    </template>
                </el-submenu>
                <el-submenu index="/model/modelList" :class="$route.path.includes('modelList')?'submenu-active':''">
                    <template slot="title">
                        <div @click="$router.replace('/model/modelList');" style="width: 100%;">钢化膜批发</div>
                    </template>
                </el-submenu>
                <el-submenu index="/material/materialColor" :class="$route.path.includes('materialColor')?'submenu-active':''">
                    <template slot="title">
                        <div @click="$router.replace('/material/materialColor');" style="width: 100%;">机型颜色</div>
                    </template>
                </el-submenu>
                <el-submenu index="/material/materialMemory" :class="$route.path.includes('materialMemory')?'submenu-active':''">
                    <template slot="title">
                        <div @click="$router.replace('/material/materialMemory');" style="width: 100%;">机型内存</div>
                    </template>
                </el-submenu>
                <el-submenu index="/material" :class="$route.path.includes('materialMemory')?'submenu-active':''">
                    <template slot="title">
                        <div @click="$router.replace('/material/materialMemory');" style="width: 100%;">代理商管理</div>
                    </template>
                </el-submenu>
            </el-menu>
        </div>
        
    </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
    props: {
        supplierinfo: {
            type: Array,
            required: false,
        },
    },
    data(){
        return{
            
        }
    },
    // 过滤器
    filters: {
        strtime(value) {
            if (!value) return;
            return dayjs(value * 1000).format('YYYY年MM月DD日 HH:mm:ss');
        },
    },
    created(){
        
        
    },
    methods:{
      
    }
}
</script>
<style lang="less" scoped>
.el-menu {
    border-right: 0;
    
    /deep/ .is-active {
        // display: flex;
        // align-items: center;
        // margin: 12px 0;
        box-shadow: 0px 1px 1px #67ffff1A;
        background: linear-gradient(to right, #67ffffA6,#67ffff1A, #67ffff00) !important;
        color: #fff !important;
    }
    /deep/ .el-menu-item{
        height: 45px;
        line-height: 45px;
        font-size: 15px;
        color: #d9d9d9;
    }
    /deep/ .el-submenu{
        margin: 12px 0;
        box-shadow: 0px 1px 1px #67ffff1A;
        background: linear-gradient(to right, #67ffff40,#67ffff1A, #67ffff00) ;
    }
    /deep/ .el-submenu__title{
        padding-left: 60px !important;
        font-size: 18px;
        height: 45px;
        line-height: 45px;
    }
}
.menu-item{
    background: linear-gradient(to right, #67ffff40,#67ffff1A, #67ffff00);
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 18%;
    min-width: 360px;
    min-height: 400px;
}

#scrollable-area {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 70vh; /* 根据需要设置 */
}

.rotate-image {
    animation: rotate 16s linear infinite;
}
.submenu-active{
        background: linear-gradient(to right, #67ffffA6,#67ffff1A, #67ffff00) !important;
    }
</style>